import { useMemo } from 'react'
import { useLocale } from './useLocale.js'
import enAiAgency from '../../i18n/locales/en/ai-agency.json'
import nbAiAgency from '../../i18n/locales/nb/ai-agency.json'
import enFixer from '../../i18n/locales/en/fixer.json'
import nbFixer from '../../i18n/locales/nb/fixer.json'
import enLanding from '../../i18n/locales/en/landing.json'
import nbLanding from '../../i18n/locales/nb/landing.json'
import enAbout from '../../i18n/locales/en/about.json'
import nbAbout from '../../i18n/locales/nb/about.json'

function usePageContent<T>(en: T, nb: T): T {
  const { locale } = useLocale()
  return useMemo(() => (locale === 'nb' ? nb : en), [locale, en, nb])
}

export function useAiAgencyContent() {
  return usePageContent(enAiAgency, nbAiAgency)
}

export function useFixerContent() {
  return usePageContent(enFixer, nbFixer)
}

export function useLandingContent() {
  return usePageContent(enLanding, nbLanding)
}

export function useAboutContent() {
  return usePageContent(enAbout, nbAbout)
}
